import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Search } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/motion";
import { getBlog } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { getBlog().then(setPosts).catch(() => {}); }, []);

  const filtered = posts.filter((p) => p.title.toLowerCase().includes(q.toLowerCase()) || (p.category || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <>
      <Seo title="India Travel Blog | Legacy India Travel" description="Travel articles, visa guides, festival calendars, packing lists and food guides for your India journey — for travellers around the world." />
      <PageHero title="Travel Journal" subtitle="Guides, tips and inspiration for your India adventure." image="https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=1600&q=80" crumbs={[{ label: "Blog" }]} />

      <section className="py-14 sm:py-20 bg-[#fdfbf7]">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <div className="flex justify-end mb-10">
            <div className="flex items-center gap-2 border border-[#d4af37]/40 bg-white px-4 py-2.5 min-w-[280px]">
              <Search className="w-4 h-4 text-[#7c1d1d]" />
              <input data-testid="blog-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search articles..." className="flex-1 bg-transparent outline-none text-sm text-[#3b1a1a]" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="blog-grid">
            {filtered.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.06}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block bg-white border border-[#d4af37]/25 hover:border-[#d4af37]/60 transition-colors overflow-hidden h-full">
                  <div className="relative overflow-hidden aspect-[3/2]"><img src={p.featured_image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1200ms]" /></div>
                  <div className="p-6">
                    <span className="text-[10px] tracking-[0.24em] uppercase text-[#14523d]">{p.category}</span>
                    <h3 className="font-serif text-2xl text-[#3b1a1a] mt-2 leading-snug group-hover:text-[#7c1d1d] transition-colors clamp-2">{p.title}</h3>
                    <p className="text-sm text-[#5a4b4b] mt-2 leading-relaxed clamp-3">{p.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-1.5 text-[11px] tracking-[0.2em] uppercase text-[#7c1d1d]">Read <ArrowUpRight className="w-3.5 h-3.5" /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
          {filtered.length === 0 && <div className="text-center py-16 text-[#5a4b4b]">No articles found.</div>}
        </div>
      </section>
    </>
  );
}
